/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon20Solid = forwardRef('MediaUiASkipForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m5.3 2.948 9.184 5.783c.227.143.4.332.516.544V4a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0v-5.275a1.49 1.49 0 0 1-.516.544l-9.185 5.783A1.5 1.5 0 0 1 3 15.783V4.217a1.5 1.5 0 0 1 2.3-1.27Z" })));
});
